import { render } from "./filtersButtonBlock.vue?vue&type=template&id=9ac9451a"
import script from "./filtersButtonBlock.vue?vue&type=script&lang=js"
export * from "./filtersButtonBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__